import type { ThemeConfig } from 'antd';
import { Color } from '../constants/Color';

export const antdThemeConfig: ThemeConfig = {
  token: {
    colorPrimary: Color.Primary,
    fontFamily: 'inherit',
  },
  components: {
    Layout: {
      headerBg: Color.Primary,
    },
    Button: {
      colorPrimary: Color.Primary,
      defaultShadow: 'none',
      primaryShadow: 'none',
    },
    Table: {
      rowHoverBg: Color.BgLightPrimarySelected,
      headerBg: Color.TableHeader,
      headerColor: Color.TableHeaderColor,
      headerBorderRadius: 0,
    },
  },
};

export default antdThemeConfig;
